import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getDivisionAPI from '../../api/get-division';
import { getDivisionReceive, getDivisionReject, getDivisionRequested } from '../actions/admin-page';

interface IGetDivisionAction {
  type: string;
  payload: {
    name: string
  }
}

interface IDivisionResponse {
  division: {
    id: string
    displayName: string
    name: string
    defaultAlertText: string
    defaultAlertTextRecommendation: string
  }[]
}

const getDivision = function* getDivision(action: IGetDivisionAction) {
  try {
    const response: IDivisionResponse = yield call(getDivisionAPI, action.payload.name);
    yield put(getDivisionReceive({ division: response }));
  } catch (error) {
    yield put(getDivisionReject({ error }));
  }
};

export default function* getDivisionWatcher() {
  yield takeLatest(getDivisionRequested, getDivision);
}
